import { addMinutes, formatISO } from 'date-fns';
import { z } from 'zod';
import { Messages } from '../../constants';
import { EventBodyContentTypeEnum } from './EventBodyContentTypeEnum';
import { calendarEventAttendeeSchema } from './ICalendarEventAttendee';
import { ICalendarEventForm } from './ICalendarEventForm';

export const calendarEventSchema = z.object({
  id: z.string().optional(),
  subject: z.string().min(1, { message: Messages.Required }),
  start: z.object({
    dateTime: z
      .string()
      .min(1, { message: Messages.Required })
      .refine(date => !isNaN(Date.parse(date)), {
        message: Messages.InvalidDateFormat,
      }),
    timeZone: z.string(),
  }),
  end: z.object({
    dateTime: z
      .string()
      .min(1, { message: Messages.Required })
      .refine(date => !isNaN(Date.parse(date)), {
        message: Messages.InvalidDateFormat,
      }),
    timeZone: z.string(),
  }),
  isAllDay: z.boolean(),
  location: z
    .object({
      displayName: z.string().optional(),
      address: z.record(z.string()).optional(), // Address as an object (key-value pairs)
    })
    .optional(),
  body: z.object({
    contentType: z.nativeEnum(EventBodyContentTypeEnum),
    content: z.string().optional(),
  }),
  attendees: z.array(calendarEventAttendeeSchema).optional(),
});
export type ICalendarEvent = z.infer<typeof calendarEventSchema>;

export const initEvent = (selectedDate: Date): ICalendarEventForm => {
  const currentTime = new Date();

  const currentMinutes = currentTime.getMinutes();
  const roundedMinutes = currentMinutes < 15 ? 0 : currentMinutes < 45 ? 30 : 0;
  const adjustedHours =
    currentMinutes >= 45 ? currentTime.getHours() + 1 : currentTime.getHours();

  const now = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    selectedDate.getDate(),
    adjustedHours,
    roundedMinutes,
    0
  );

  const defaultStartDateTime = formatISO(now, {
    representation: 'complete',
  });

  const thirtyMinutesLater = addMinutes(now, 30);

  const defaultEndDateTime = formatISO(thirtyMinutesLater, {
    representation: 'complete',
  });

  return {
    subject: '',
    start: {
      dateTime: defaultStartDateTime,
      timeZone: 'UTC',
    },
    end: {
      dateTime: defaultEndDateTime,
      timeZone: 'UTC',
    },
    body: { contentType: EventBodyContentTypeEnum.Text },
    isAllDay: false,
    // isCancelled: false,
    // responseRequested: true,
    // importance: 'normal',
    // showAs: 'busy',
    requiredAttendees: [],
    optionalAttendees: [],
    // webLink: '',
    // createdDateTime: new Date().toISOString(),
    // lastModifiedDateTime: new Date().toISOString(),
    // organizer: { emailAddress: { name: LastName, address: Email } },
    // calendar: { name: 'Calendar' },
  };
};
